// 16 perceptually distinct, vivid colors — well separated on the color wheel
// and dark enough to contrast with white text.
export const COLOR_PALETTE = [
    "#1565C0", // deep blue
    "#C62828", // deep red
    "#2E7D32", // deep green
    "#E65100", // deep orange
    "#6A1B9A", // deep purple
    "#00695C", // deep teal
    "#AD1457", // deep pink
    "#283593", // indigo
    "#4E342E", // brown
    "#00838F", // dark cyan
    "#558B2F", // dark lime
    "#BF360C", // burnt orange
    "#37474F", // blue-grey
    "#4527A0", // violet
    "#0277BD", // dark light-blue
    "#880E4F", // deep magenta
];

/**
 * Deterministically pick a vivid color from a fixed palette.
 * Uses a finalised hash (Murmur-style mixing) so similar strings
 * like "P-001" / "P-002" map to visually distinct palette entries.
 */
export function stringToColor(str = "") {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    hash ^= hash >>> 16;
    hash = Math.imul(hash, 0x45d9f3b);
    hash ^= hash >>> 16;
    return COLOR_PALETTE[Math.abs(hash) % COLOR_PALETTE.length];
}
